import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styled from 'styled-components';

interface IconLinkProps extends LinkProps {
	iconClass: string;
}

export default function IconLink(props: React.PropsWithChildren<IconLinkProps>) {
	const { iconClass, children, ...rest } = props;

	return (
		<Wrapper {...rest}>
			<i className={iconClass} />
			{children}
		</Wrapper>
	);
}

const Wrapper = styled(Link)`
	display: inline-flex;
	align-items: center;
	justify-content: center;

	i {
		margin-right: 1rem;
	}
`;
